const Confirmation = (props) => {
	const { onConfirm, onCancel, title, desc } = props;
	return (
		<div className='bg-white p-4 shadow-custom transition-transform duration-1000 ease-in-out rounded-t-xl translate-y-0 relative'>
			<div className='pt-4 text-base text-gray-900 font-semibold'>{title ?? 'Apakah Anda yakin ingin mengubah tipe pesanan?'}</div>
			<div className='pt-1 text-xxs text-gray-900 font-normal'>{desc ?? 'Beberapa Produk yang tidak tersedia untuk order tipe ini, makanan atau nomor meja yang telah dipilih akan hilang'}</div>
			<div className='flex gap-2 mt-10'>
				<button className='w-full bg-[var(--rose-violet)] text-white flex justify-center font-normal text-sm py-2 px-3 border-0 items-center' onClick={onConfirm}>
					Ya
				</button>
				<button className='w-full bg-white text-[var(--rose-violet)] border-3 border-[var(--rose-violet)] flex justify-center font-normal text-sm py-2 px-3 items-center' onClick={onCancel}>
					Tidak
				</button>
			</div>
		</div>
	);
};

export default Confirmation;
